import { useRef } from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import Button from 'components/Button/Button';

import { FileUploaderProps } from './FileUploader.types';

export const FileUploader = ({
    title = 'Upload Asset',
    description = 'Will be scaled down to 32 × 32px',
    onFileSelect,
    accept = 'image/*',
    dualButtons = false,
    className = '',
    disabled = false,
    selectedFile = null,
    onFileRemove,
}: FileUploaderProps) => {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const fileInputRef2 = useRef<HTMLInputElement>(null);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            onFileSelect(file);
        }
        event.target.value = '';
    };

    const handleButtonClick = (inputRef: React.RefObject<HTMLInputElement>) => {
        if (!disabled) {
            inputRef.current?.click();
        }
    };

    return (
        <div
            className={`flex justify-between items-center self-stretch border border-dashed border-base-mutedForeground bg-base-secondary rounded-md px-8 py-9 ${className}`}
        >
            <div className="flex flex-col gap-1 flex-1 min-w-0">
                <h3 className="text-base text-base-primary">{title}</h3>
                {selectedFile ? (
                    <div className="flex items-center gap-2 min-w-0">
                        <FontAwesomeIcon icon="fa-regular fa-file" className="text-base-mutedForeground flex-shrink-0" />
                        <p className="text-sm text-base-foreground truncate max-w-[150px]" title={selectedFile.name}>
                            {selectedFile.name}
                        </p>
                        {onFileRemove && (
                            <button
                                onClick={onFileRemove}
                                className="ml-1 flex-shrink-0 text-base-mutedForeground hover:text-base-destructive transition-colors"
                                type="button"
                            >
                                <FontAwesomeIcon icon="fa-regular fa-xmark" className="w-4 h-4" />
                            </button>
                        )}
                    </div>
                ) : (
                    <p className="text-xs text-base-sidebarRing">{description}</p>
                )}
            </div>

            <div className="flex gap-3">
                <div>
                    <input
                        ref={fileInputRef}
                        type="file"
                        accept={accept}
                        onChange={handleFileChange}
                        className="hidden"
                        disabled={disabled}
                    />
                    <Button
                        onClick={() => handleButtonClick(fileInputRef)}
                        disabled={disabled}
                        rightIcon={<FontAwesomeIcon icon="fa-light fa-database" className="!text-lg" />}
                        className={`
              px-6 py-2.5
              bg-base-border rounded-lg
              text-base-secondaryForeground
              transition-colors border border-base-border
              ${disabled
                                ? 'opacity-50 cursor-not-allowed'
                                : 'hover:bg-base-accent cursor-pointer'
                            }
            `}
                    >
                        Upload
                    </Button>
                </div>
                {dualButtons && (
                    <div>
                        <input
                            ref={fileInputRef2}
                            type="file"
                            accept={accept}
                            onChange={handleFileChange}
                            className="hidden"
                            disabled={disabled}
                        />
                        <button
                            type="button"
                            onClick={() => handleButtonClick(fileInputRef2)}
                            disabled={disabled}
                            className={`
                flex items-center justify-center p-3
                bg-base-muted text-base-foreground rounded-lg
                transition-colors border border-base-border
                ${disabled
                                    ? 'opacity-50 cursor-not-allowed'
                                    : 'hover:bg-base-accent cursor-pointer'
                                }
              `}
                        >
                            <FontAwesomeIcon icon="fa-solid fa-database" className="text-lg" />
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

